var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31442 19.6867C7.73222 20.1045 8.40582 20.1045 8.82362 19.6867L15.9091 12.6011C15.9882 12.5222 16.0509 12.4285 16.0937 12.3254C16.1365 12.2222 16.1585 12.1117 16.1585 12C16.1585 11.8883 16.1365 11.7778 16.0937 11.6746C16.0509 11.5715 15.9882 11.4778 15.9091 11.3989L8.82362 4.31335C8.40582 3.89555 7.73222 3.89555 7.31442 4.31335C6.89662 4.73115 6.89662 5.40474 7.31442 5.82254L13.4876 12.0043L7.3059 18.186C6.89662 18.5953 6.89662 19.2774 7.31442 19.6867Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.334dc719e3c03dd440c2d43f8f2e97ea.svg";
export { ForwardRef as ReactComponent };